// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"07932474","480":"53e1f5ad","838":"a5f912f8"}[chunkId] + ".js";
};